// JS adapted from warranty.js in SFCC code

/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-empty */

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {String} url the url to which the parameter will be added
 * @param {String} name the name of the parameter
 * @param {String} value the value of the parameter
 */
function appendParamToURL(url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
}

function initWarrantyWindowVar() {
  window.StickWarranty = {customerInfo: {valid: false, needPhotos: 1},standardStickArray:[],personalStickArray:[]};
}

/**
 * @function
 * @description appends the parameters to the given url and returns the changed url
 * @param {String} url the url to which the parameters will be added
 * @param {Object} params
 */
function appendParamsToUrl(url, params) {
    var _url = url;
    Object.keys(params).forEach(function(name) {
        const value = params[name];
        _url = this.appendParamToURL(_url, name, value);
    }.bind(this));
    return _url;
}

/**
 * @function
 * @description Updates the number of the remaining character
 * based on the character limit in a text area
 */
function limitCharacters() {
    $('form').find('textarea[data-character-limit]').each(function () {
        var characterLimit = $(this).data('character-limit');
        var charCountHtml = String.format(window.Resources.CHAR_LIMIT_MSG,
            '<span class="char-remain-count">' + characterLimit + '</span>',
            '<span class="char-allowed-count">' + characterLimit + '</span>');
        var charCountContainer = $(this).next('div.char-count');
        if (charCountContainer.length === 0) {
            charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).change();
    });
}

function populateModelNumber() {
    var $modelNumberField = $('.js-model-number').find('select[name$="_modelnumber"]');
    var modelNumbers = window.BatModelNumbers;

    if ($modelNumberField.length > 0) {
        Object.keys(modelNumbers).forEach(function(key) {
            $modelNumberField.append('<option class="select-option" label="' + key + '" value="' + key + '">' + key + '</option>');
        });
    }
}

function populateLengthWeight() {
    var $batLengthWeightField = $('.js-bat-lengthweight').find('select[name$="_batLengthWeight"]');
    $('.js-model-number').find('select[name$="_modelnumber"]').on('change', function() {
        var selection = $(this).val();
        var modelNumbers = window.BatModelNumbers;
        var lengthWeights = modelNumbers[selection].lengthWeights;

        $batLengthWeightField.html('<option class="select-option" label="Select..." value="">Select...</option>');

        Object.keys(lengthWeights).forEach(function(key) {
            $batLengthWeightField.append('<option class="select-option" label="' + lengthWeights[key] + '" value="' + key + '">' + lengthWeights[key] + '</option>');
        });
    });
}

function isRetailer(){
  let retailRtn = true;
  if(!window.StickWarranty.customerInfo.valid){
    retailRtn = false;
  }
  if(window.StickWarranty.customerInfo.dwfrm_stickwarranty_amiretailer != 'retailer'){
    retailRtn = false;
  }
  return retailRtn;
}
function orderModeDisplay(orderMode){
  if($('.file-upload').hasClass('u-display-none')) {
    $('.file-upload').removeClass('u-display-none');
  }
	switch(orderMode){
		case 'storeorder':
			if (!$('.js-standardorder').hasClass('u-display-none')) {
				$('.js-standardorder').addClass('u-display-none');
			}
			if($('.receipt-img').hasClass('u-display-none')) {
				$('.receipt-img').removeClass('u-display-none');
			}
			if($('.js-purchasedate').hasClass('u-display-none')) {
				$('.js-purchasedate').removeClass('u-display-none');
			}
      $('input[name*="_storepostal"]').attr('value', window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_postal);
      $('input[name*="_storecountry"]').attr('value', window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_country);
			populateStateAddress();
			break;
		case 'onlineorder':
			if (!$('.js-store-pincode').hasClass('u-display-none')) {
				$('.js-store-pincode').addClass('u-display-none');
			}
			if (!$('.js-store-country').hasClass('u-display-none')) {
				$('.js-store-country').addClass('u-display-none');
			}
			if (!$('.js-stick-store-location').hasClass('u-display-none')) {
				$('.js-stick-store-location').addClass('u-display-none');
			}
			if (!$('.js-stick-other-location').hasClass('u-display-none')) {
				$('.js-stick-other-location').addClass('u-display-none');
			}
			if ($('.js-standardorder').hasClass('u-display-none')) {
				$('.js-standardorder').removeClass('u-display-none');
			}
			if(!$('.receipt-img').hasClass('u-display-none')) {
				$('.receipt-img').addClass('u-display-none');
			}
			if(!$('.js-purchasedate').hasClass('u-display-none')) {
				$('.js-purchasedate').addClass('u-display-none');
			}
			$('.js-modeoforder').find('input[name*="_modeoforder"]').attr('disabled', false);
			break;
		case 'clear':
			if (!$('.js-store-pincode').hasClass('u-display-none')) {
				$('.js-store-pincode').addClass('u-display-none');
			}
			if (!$('.js-store-country').hasClass('u-display-none')) {
				$('.js-store-country').addClass('u-display-none');
			}
			if (!$('.js-stick-store-location').hasClass('u-display-none')) {
				$('.js-stick-store-location').addClass('u-display-none');
			}
			if (!$('.js-stick-other-location').hasClass('u-display-none')) {
				$('.js-stick-other-location').addClass('u-display-none');
			}
			if (!$('.js-standardorder').hasClass('u-display-none')) {
				$('.js-standardorder').addClass('u-display-none');
			}
			if(!$('.receipt-img').hasClass('u-display-none')) {
				$('.receipt-img').addClass('u-display-none');
			}
			if(!$('.js-purchasedate').hasClass('u-display-none')) {
				$('.js-purchasedate').addClass('u-display-none');
			}
			$('.js-modeoforder').find('input[name*="_modeoforder"]').attr('disabled', false);
			break;
		case 'retailer':
			if (!$('.js-modeoforder-container').hasClass('u-display-none')) {
				$('.js-modeoforder-container').addClass('u-display-none');
			}
      if(window.StickWarranty.customerInfo.needPhotos == 0) {
        if(!$('.file-upload').hasClass('u-display-none')) {
          $('.file-upload').addClass('u-display-none');
        }
        $('.c-stick-warranty__upload-item').each(function(){
          if(!$(this).hasClass('u-display-none')) {
            $(this).addClass('u-display-none');
          }
        })
      }
			if($('.js-purchasedate').hasClass('u-display-none')) {
				$('.js-purchasedate').removeClass('u-display-none');
			}
      $('.js-modeoforder').removeClass('required').find('.input-radio').each(function(){
        $(this).attr('required',false);
      })
			break;
	}
}

function manageError(showMe,errMessage='',warrantyPage){
	var errorContainer;
  switch (warrantyPage){
    case 'stickwarranty2': {
      errorContainer = $('#stickwarranty2 .field-container .general-error-message');
      break;
    }
    default:
      errorContainer = $('#stickwarrantyReview .error-message');
  }

	if(showMe){
    if(errMessage.length){
      errorContainer.html('<p><strong>' + errMessage + '</strong></p>');
    }
		errorContainer.removeClass('u-display-none');
	} else {
		errorContainer.hide().find('ul').html('');
	}
}

/**
 * @private
 * @function
 * @description Binds the events of the stick warranty form
 */
function initStickWarrantyForm() {

    // remove server side error
    $('.required.error').removeClass('error');

    //Set display with Navigation
    navigateForms('home');

    //prevents form to submit on press of enter button
    $('#stickwarranty,#stickwarranty2,#stickwarranty3').on('keyup keypress', function(e){
        var keycode = e.keycode || e.which;
        if(keycode === 13){
            e.preventDefault();
            if($(e.target).length && $(e.target).is('input,select')){
              $(e.target).blur();
            }
            return false;
        }
    });

    //Populate Stick Model block
    $('.js-product-type').find('select[name$="_productType"]').on('change', function() {
    	disableSubstitudeOptions();
        const parentForm = $(this).closest('form'),
          isStandard = (parentForm.attr('id') == 'stickwarranty2'),
          productType = parentForm.find('select[name$="_productType"]').val(),
          modelField = parentForm.find('select[name*="_modelnumber"]'),
          flexField = parentForm.find('select[name*="_stickFlex"]'),
          handVariationField = parentForm.find('select[name*="_handVariation"]'),
          stickPatternField = parentForm.find('select[name*="_stickPattern"]');

        if(isStandard) {
          modelField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '" value="loading">' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '</option>');
          flexField.prop('disabled', true);
          flexField.append('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
          handVariationField.prop('disabled', true);
          stickPatternField.prop('disabled', true);
          handVariationField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
          stickPatternField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
        }

        var productTypeNumber;

        switch(productType){
          case 'sticks':
            productTypeNumber = 1;
            $('.js-flex-number').find('label').text(window.Resources.STICK_FLEX + "*");
            if (parentForm.find('.js-stick-breakage').hasClass('u-display-none')) {
              parentForm.find('.js-stick-breakage').removeClass('u-display-none');
            }

            if (!parentForm.find('.js-goalie-breakage').hasClass('u-display-none')) {
                parentForm.find('.js-goalie-breakage').addClass('u-display-none');
            }
            break;
          case 'blades':
            productTypeNumber = 2;
            break;
          case 'goalie':
            productTypeNumber = 3;
            $('.js-flex-number').find('label').text(window.Resources.STICK_PADDLE_SIZE + "*");
            if (parentForm.find('.js-goalie-breakage').hasClass('u-display-none')) {
              parentForm.find('.js-goalie-breakage').removeClass('u-display-none');
            }

            if (!parentForm.find('.js-stick-breakage').hasClass('u-display-none')) {
                parentForm.find('.js-stick-breakage').addClass('u-display-none');
            }
            break;
          case 'shafts':
            productTypeNumber = 4;
            break;
        }

        var stickModelFlexPatternURL = window.Urls.stickModelFlexPattern + '?productTypeId=' + productTypeNumber + '&stickProperty=model';
        $.ajax({
            type: 'POST',
            url: stickModelFlexPatternURL,
            dataType: 'json'
        }).done (function (response){
            if(response.statusCode === 200){
                var parseMessage = response.message;
                modelField.find('[value="loading"]').remove();
                modelField.prop('disabled', false);
                modelField.append('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
                for(var count=0; count<parseMessage.length; count++){
                    modelField.append('<option class="select-option" label="' + parseMessage[count].modelName + '" value="' + parseMessage[count].modelId + ':' + parseMessage[count].modelName + '">' + parseMessage[count].modelName + '</option>');
                }
                modelField.append('<option class="select-option" label="' + window.Resources.STOCK_STICK_NOT_FOUND_LABEL + '" value="contactcustomerservice">' + window.Resources.STOCK_STICK_NOT_FOUND_VALUE + '</option>');
            }
        });
    });

    //Populate Stick Flex block
    $('.js-stick-model-number').find('select[name$="_modelnumber"]').on('change', function() {
    	disableSubstitudeOptions();
        var modelNumber = $('select[name$="_modelnumber"]').val();
        modelNumber = modelNumber.split(':');
        var flexField = $('select[name*="_stickFlex"]');

        flexField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '" value="loading">' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '</option>');
        var handVariationField = $('select[name*="_handVariation"]');
        var stickPatternField = $('select[name*="_stickPattern"]');
        handVariationField.prop('disabled', true);
        stickPatternField.prop('disabled', true);
        handVariationField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
        stickPatternField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');

    	if((modelNumber.indexOf('contactcustomerservice')) >= 0){
    		var stickDesSub = $('<span class="stick-description">' + window.Resources.NO_SUBSTITUTE_STICK_FIND + ' ' + window.Resources.ANOTHER_SUBSTITUTE_STICK + '</span>');
            stickDesSub.appendTo('.js-stick-image');
            $('.js-stick-image').removeClass('u-display-none');
            disableAnotherReviewButton('#stickwarranty2');
    	}else{
    		enableAnotherReviewButton();
    		var stickModelFlexPatternURL = window.Urls.stickModelFlexPattern + '?productModelId=' + modelNumber[0] + '&stickProperty=flex';
            $.ajax({
                type: 'POST',
                url: stickModelFlexPatternURL,
                dataType: 'json'
            }).done (function (response){
                if(response.statusCode === 200){
                    var parseMessage = JSON.parse(response.message);
                    flexField.find('[value="loading"]').remove();
                    flexField.prop('disabled', false);
                    flexField.append('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
                    for(var count=0; count<parseMessage.Items.length; count++){
                        flexField.append('<option class="select-option" label="' + parseMessage.Items[count].Flex.S + '" value="' + parseMessage.Items[count].ProductVariantId.N + ':' + parseMessage.Items[count].Flex.S + '">' + parseMessage.Items[count].Flex.S + '</option>');
                    }
                }
            });
    	}
    });

    //Populate Stick Hand Variation and Pattern block
    $('.js-flex-number').find('select[name$="_stickFlex"]').on('change', function() {
    	disableSubstitudeOptions();
        var flexValue = $('select[name$="_stickFlex"]').val();
        flexValue = flexValue.split(':');
        var handVariationField = $('select[name*="_handVariation"]');
        var stickPatternField = $('select[name*="_stickPattern"]');
        handVariationField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '" value="loading">' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '</option>');
        stickPatternField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '" value="loading">' + window.Resources.STICK_WARRANTY_LOADING_LABEL + '</option>');

        var stickModelFlexPatternURL = window.Urls.stickModelFlexPattern + '?productVariantId=' + flexValue[0] + '&stickProperty=handPattern';
        $.ajax({
            type: 'POST',
            url: stickModelFlexPatternURL,
            dataType: 'json'
        }).done (function (response){
            if(response.statusCode === 200){
                enableAnotherReviewButton('#stickwarranty2');
                var parseMessage = JSON.parse(response.message);
                handVariationField.find('[value="loading"]').remove();
                handVariationField.prop('disabled', false);
                stickPatternField.find('[value="loading"]').remove();
                stickPatternField.prop('disabled', false);
                handVariationField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
                stickPatternField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
                for(var count=0; count<parseMessage.Items.length; count++){
                    var handVariationValueCount = $("select[name*='_handVariation'] option:contains(" + parseMessage.Items[count].Dimension1.S + ")").length;
                    if(handVariationValueCount < 1){
                        handVariationField.append('<option class="select-option" label="' + parseMessage.Items[count].Dimension1.S + '" value="' + parseMessage.Items[count].Dimension1.S + '">' + parseMessage.Items[count].Dimension1.S + '</option>');
                    }
                    var stickPatternValueCount = $("select[name*='_stickPattern'] option[value=" + parseMessage.Items[count].Dimension2.S + "]").length;
                    if(stickPatternValueCount < 1) {
                        stickPatternField.append('<option class="select-option" label="' + parseMessage.Items[count].Dimension2.S + '" value="' + parseMessage.Items[count].Dimension2.S + '">' + parseMessage.Items[count].Dimension2.S + '</option>');
                    }
                }
            } else {
              if ($('.js-nostick-variationid').hasClass('u-display-none')) {
                $('.js-nostick-variationid').removeClass('u-display-none');
              }
              disableAnotherReviewButton('#stickwarranty2');
            }
        });
    });

    //Get product id after selecting stick variants
    $('.js-stick-pattern').find('select[name*="_stickPattern"]').on('change', function(){
    	disableSubstitudeOptions();
    	initCheckProductAvailability();
    });

    //Get product id after selecting stick variants
    $('.js-hand-variation').find('select[name*="_handVariation"]').on('change', function(){
    	disableSubstitudeOptions();
    	initCheckProductAvailability();
    });

    //sets window location href on clicking previous button
    $('.js-stick-warranty-previous').on('click', function(ele){
    	ele.preventDefault();
      navigateForms('previous');
    });

    //Reset form and send home
    $('.c-stick-warranty-delete').on('click', function(ele){
    	ele.preventDefault();
      initWarrantyWindowVar();
      $('#stickwarranty').trigger("reset");
      navigateForms('home');
    });

    //Add another stick
    $('#stickwarrantyReview .c-stick-warranty-another').on('click', function(ele){
    	ele.preventDefault();
      navigateForms('home');
    });

    //Reset form and send home
    $('.c-stick-warranty-submit').on('click', function(ele){
    	ele.preventDefault();
      $(this).prop('disabled', true);
      processReturn();
    });

    //populate store location if customer changes the store postal code
    $('.js-store-pincode').on('change', function(){
    	populateStateAddress();
    });

    //populate store location if customer changes the store country code
    $('.js-store-country').on('change', function(){
    	populateStateAddress();
    });

    //show purchase location input on the user selection of purchase mode
    $('.js-modeoforder').find('input[name*="_modeoforder"]').on('change', function(){
    	enableAnotherReviewButton();
    	$('.js-modeoforder').find('input[name*="_modeoforder"]').attr('disabled', true);
    	$('#stick-modeoforder-error').css('display', 'none');
        $('#stick-modeoforder-error').remove();
        var orderMode = $('input[name$="_modeoforder"]:checked').val();
        if($('.js-standardorder').find('span.order-msg')){
            $('span.order-msg').remove();
        }
        if($('.js-standardorder').find('span.order-error-msg')){
            $('span.order-error-msg').remove();
        }

        orderModeDisplay(orderMode);
    });

    //check if user entered order number is valid or not not
    $('.js-standardorder').find('input[name*="_ordernumber"]').on('change', function(){
    	if($('.js-standardorder').find('span.order-msg')){
            $('span.order-msg').remove();
        }
        if($('.js-standardorder').find('span.order-error-msg')){
            $('span.order-error-msg').remove();
        }
        if($('.js-standardorder').find('#dwfrm_stickwarranty_orderdate')){
            $('#dwfrm_stickwarranty_orderdate').val('');
        }
        var orderNumber = $('input[name$="_ordernumber"]').val();
        var findOrderURL = window.Urls.findOrder + '?orderNumber=' + orderNumber;
        disableAnotherReviewButton('#stickwarranty2');

        $.ajax({
            type: 'POST',
            url: findOrderURL,
            dataType: 'json'
        }).done(function (response){
        	var orderMsg = document.createElement('span');

        	if(response.orders){
        		if(response.orderExpires){
        			var orderErrorMsg = document.createElement('span');
        			orderErrorMsg.innerHTML = window.Resources.ORDER_EXPIRES + ' ' + window.Resources.ORDER_FOUND + ' ' + response.orderDate;
        			orderErrorMsg.className = 'order-error-msg';
            		$('.js-standardorder').append(orderErrorMsg);
            		sessionStorage.setItem('orderNumberError', 'true');
        		}else{
        			orderMsg.innerHTML = window.Resources.ORDER_FOUND + ' ' + response.orderDate;
            		orderMsg.className = 'order-msg';
            		$('.js-standardorder').append(orderMsg);
                $('#dwfrm_stickwarranty_orderdate').val(response.orderDate);
            		sessionStorage.setItem('orderNumberError', 'false');
            		enableAnotherReviewButton('#stickwarranty2');
        		}
        	}else{
        		orderMsg.innerHTML = window.Resources.ORDER_NOT_FOUND;
        		orderMsg.className = 'order-msg';
        		$('.js-standardorder').append(orderMsg);
        		sessionStorage.setItem('orderNumberError', 'true');
        	}
        });
    });

    //show other store text box if customer's purchase store not present in dropdown
    $('.js-stick-store-location').find('select[name*="_stickstorename"]').on('change', function(){
    	var storeLocation = $('select[name$="_stickstorename"]').val();
    	if(storeLocation === 'otherstore'){
    		if ($('.js-stick-other-location').hasClass('u-display-none')) {
		        $('.js-stick-other-location').removeClass('u-display-none');
		    }
    	}else{
    		if (!$('.js-stick-other-location').hasClass('u-display-none')) {
		        $('.js-stick-other-location').addClass('u-display-none');
		    }
    	}
    });

    $('.js-substitute-option').find('select[name*="_substituteoptions"]').on('change', function(){
    	enableAnotherReviewButton();
    	if (!$('.js-stick-image').hasClass('u-display-none')) {
            $('.js-stick-image').addClass('u-display-none');
        }
    	$('.stick-description').remove();
    	$('.stick-warranty-image').attr('src', '');
    	var substituteStickImage = $('select[name$="_substituteoptions"] option:selected').val();
    	showStickImage(substituteStickImage, 'substitudeStick');
    });

    $('.js-amiretailer').find('input[name*="_amiretailer"]').on('change', function(){
    	$('#stick-amiretailer-error').css('display', 'none');
        $("#stick-amiretailer-error").remove();
    	toggleFormElementes();
    });

    $('input[name*="_shipto"]').on('change', function(){
    	$('#stickwarranty').find('button[name*="_next"]').prop('disabled', true);
    	$('#dwfrm_stickwarranty_shipto_country').val('');
    	$('.retailer-msg').remove();
    	$('.retailer-error-msg').remove();
        var shiptoID = $('input[name$="_shipto"]').val();
        var shiptToURL = window.Urls.getShipToIDAddress + '?shiptoId=' + shiptoID;

        $.ajax({
          type: 'POST',
    	    url: shiptToURL,
    	    dataType: 'json'
        }).done(function (response){
    	    if(response.statusCode === 200){
                var shipMsg;
    		    if(response.shipIDfound){
    		    	var parseMessage = JSON.parse(response.message);
              window.StickWarranty.customerInfo.needPhotos = parseMessage.Items[0].needPhotos.N;
    		    	shipMsg = $('<div class="retailer-msg">' +  window.Resources.RETAILER_SHIPPING_ADDRESS + ': <div class="retialer-address"> <span>' + parseMessage.Items[0].shipToName.S + ', </span> <span>' + parseMessage.Items[0].streetAddress.S + ', </span> <span>' + parseMessage.Items[0].city.S + ', ' + parseMessage.Items[0].country.S + ', ' + parseMessage.Items[0].postal.S + '</span> </div> <div class="retailer-customercare-msg">' + window.Resources.RETAILER_SHIPPING_ADDRESS_FOUND + '</div>');
                    $('.c-form-retailer-ship-to').after(shipMsg);
                    $('.c-form-retailer-email').css('display', 'block');
                    $('#stickwarranty').find('button[name*="_next"]').prop('disabled', false);
                    $('#dwfrm_stickwarranty_shipto_country').val(parseMessage.Items[0].country.S);
    		   }else{
                    shipMsg = $('<div class="retailer-error-msg">' + window.Resources.RETAILER_SHIPPING_ADDRESS_NOT_FOUND + '</div>');
                    $('.c-form-retailer-ship-to').after(shipMsg);
                    $('.c-form-retailer-email').css('display', 'none');
                }
            }
        });
    });

    $('input[name*="_postal"]').keyup(function () {
        $(this).val($(this).val().toUpperCase());
    });

    $('input[name*="_storepostal"]').keyup(function () {
        $(this).val($(this).val().toUpperCase());
    });

    $('.c-stick-warranty__container').find('input[name*="_sticktype"]').on('change', function(){
    	$('#stick-type-error').css('display', 'none');
        $('#stick-type-error').remove();
    });

    $('#stickwarranty').find('button[name*="_next"]').on('click', function(e){
    	var selectionMade = true, formValid = true;
      var stickType;
    	if($('.c-stick-warranty__container').find('input[name*="_sticktype"]').length > 0){
    		selectionMade = $('input[name*=_sticktype]').is(':checked');
        stickType = $('input[name*=_sticktype]:checked').val();
    		if(!selectionMade){
    			e.preventDefault();
    			$('#stick-type-error').css('display', 'block');
                $("#stick-type-error").html(
    			    '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> ' + window.Resources.STICK_TYPE_ERROR_MSG + ' </div>'
                );
    		}
    	}

      formValid = $('#stickwarranty').valid();
      if(formValid){
        if($('.c-stick-warranty__container').find('.js-amiretailer').length > 0){
          selectionMade = $('.js-amiretailer').find('input[name*=_amiretailer]').is(':checked');
          if(!selectionMade){
            e.preventDefault();
            $('#stick-amiretailer-error').css('display', 'block');
            $("#stick-amiretailer-error").html(
              '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> ' + window.Resources.CONSUMER_TYPE_ERROR_MSG + ' </div>'
            );
          }
        }
        if(selectionMade){
          // Storing all the customer data from the form into StickWarranty object
          $.each($('#stickwarranty').serializeArray(), function(_, kv) {
            if (kv.name != 'dwfrm_stickwarranty_sticktype') {
              if (window.StickWarranty.customerInfo.hasOwnProperty(kv.name)) {
                window.StickWarranty.customerInfo[kv.name] = '';
                window.StickWarranty.customerInfo[kv.name] = kv.value;
              }
              else {
                window.StickWarranty.customerInfo[kv.name] = kv.value;
              }
            }
          });
          window.StickWarranty.customerInfo.valid = true;
          navigateForms(stickType + '-stick');
        }
      }
    });
    $('#stickwarranty2,#stickwarranty3').find('button[name*="_anotherstick"]').on('click', function(e){
      const theForm = $(this).closest('form');
    	let selectionMade = true, error = false, formValid = true, sessionValid = sessionClear();
    	if($(theForm).attr('id') == 'stickwarranty2' && $('.c-stick-warranty__container').find('.js-modeoforder').length > 0 && !isRetailer()){
    		selectionMade = $('.js-modeoforder').find('input[name*="_modeoforder"]').is(':checked');
    		if(!selectionMade){
    			e.preventDefault();
    			$('#stick-modeoforder-error').css('display', 'block');
                $("#stick-modeoforder-error").html(
    			    '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> Please select mode of purchase. </div>'
                );
    		}
    	}
    	if($('.c-stick-warranty__container').find('.file-upload').length > 0){
    		error = checkImagesSelected(theForm);
        	if(error){
        		e.preventDefault();
        	}
    	}
    	formValid = $(theForm).valid();

    	if(selectionMade && !error && formValid && sessionValid){
        var navigateFrom = saveStick(theForm);
        if(navigateFrom){
          navigateForms('home');
        }
    	}
    });

    $('#stickwarranty2,#stickwarranty3').find('button[name*="_review"]').on('click', function(e){
      const theForm = $(this).closest('form');
    	let selectionMade = true, error = false, formValid = true, sessionValid = sessionClear();
    	if($(theForm).attr('id') == 'stickwarranty2' && $('.c-stick-warranty__container').find('.js-modeoforder').length > 0 && !isRetailer()){
    		selectionMade = $('.js-modeoforder').find('input[name*="_modeoforder"]').is(':checked');
    		if(!selectionMade){
    			e.preventDefault();
    			$('#stick-modeoforder-error').css('display', 'block');
                $("#stick-modeoforder-error").html(
    			    '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> Please select mode of purchase. </div>'
                );
    		}
    	}
    	if($('.c-stick-warranty__container').find('.file-upload').length > 0){
    		error = checkImagesSelected(theForm);
        	if(error){
        		e.preventDefault();
        	}
    	}
    	formValid = $(theForm).valid();

    	if(selectionMade && !error && formValid && sessionValid){
        var navigateFrom = saveStick(theForm);
        if(navigateFrom){
          navigateForms('review');
        }
    	}
    });
}

function saveStick(stickForm){
  // Storing all the stick data from the form and inserting into array
  let stickObj = {};
  var errorOut = false;

  $.each($(stickForm).serializeArray(), function(_, kv) {
    if(kv.name == 'dwfrm_stickwarranty_origproduct' && kv.value == ''){
      errorOut = true;
    } else if(kv.name == 'dwfrm_stickwarranty_replaceproduct' && kv.value == ''){
      errorOut = true;
    }
    stickObj[kv.name] = kv.value;
    if(kv.name == 'dwfrm_stickwarranty_substituteoptions'){
      stickObj['dwfrm_stickwarranty_substitutelabel'] = $('#dwfrm_stickwarranty_substituteoptions option:selected').attr('label');
    }
  });

  if(errorOut){
    manageError(true,'','stickwarranty2');
    return false;
  }else{
    //Add to correct stick array
    if($(stickForm).attr('id') == 'stickwarranty2'){
      window.StickWarranty.standardStickArray.push(stickObj);
    }else{
      window.StickWarranty.personalStickArray.push(stickObj);
    }
    //Clear Form incase of another stick
    stickForm.trigger("reset");
    return true;
  }
}

function sessionClear(){
  var serialNumberValid = sessionStorage.getItem('serialNumberError');
  var orderNumberValid =  sessionStorage.getItem('orderNumberError');
  var productValid =  sessionStorage.getItem('productError');

  return (serialNumberValid === 'false' &&  orderNumberValid === 'false' &&  productValid === 'false');
}

function disableAnotherReviewButton(myForm){
    $(myForm).find('button[name*="_anotherstick"]').prop('disabled', true);
    $(myForm).find('button[name*="_review"]').prop('disabled', true);
}

function enableAnotherReviewButton(myForm){
    if(sessionClear()){
        $(myForm).find('button[name*="_anotherstick"]').prop('disabled', false);
        $(myForm).find('button[name*="_review"]').prop('disabled', false);
    }
}

function displayOverlay(theParent,isShow){
  if(isShow){
    $(theParent).find('.c-stick-warranty__overlay').css('display', 'block').find('.c-stick-warranty__loader.loading-pages').css('display', 'block');
  } else {
    $(theParent).find('.c-stick-warranty__overlay').css('display', 'none').find('.c-stick-warranty__loader.loading-pages').css('display', 'none');
  }
}

function getFlexMap(flex, stickType){
    var flexmap;

    if(stickType === 'sticks'){
    	switch(flex){
            case '112':
        	    flexmap = '102%7C112%7C87';
        	    break;
            case '102':
        	    flexmap = '102%7C87';
        	    break;
            case '87':
        	    flexmap = '102%7C87%7C77';
        	    break;
            case '77':
        	    flexmap = '87%7C77%7C70';
        	    break;
            case '70':
        	    flexmap = '77%7C70%7C67';
        	    break;
            case '67':
        	    flexmap = '67%7C60%7C65';
        	    break;
            case '55':
        	    flexmap = '60%7C55%7C50';
        	    break;
            case '50':
        	    flexmap = '50%7C55%7C40';
        	    break;
            case '40':
        	    flexmap = '30%7C40%7C50';
        	    break;
            case '30':
        	    flexmap = '20%7C30%7C40';
        	    break;
            case '20':
        	    flexmap = '20%7C30';
        	    break;
            case '60':
        	    flexmap = '60%7C67%7C55%7C65';
        	    break;
            case '65':
        	    flexmap = '60%7C67%7C65';
        	    break;
        }
    }else if(stickType === 'goalie'){
    	if(flex.indexOf(' ') > 0){
    		var splitFlex = flex.split(' ');
    		flexmap = splitFlex[0];
    	}else{
    		flexmap = flex;
    	}
    }

    return flexmap;
}

function getFlexUnMap(flex){
  let rtnStr;

  if(flex.indexOf(':') > 0){
    let splitFlex = flex.split(':');
    rtnStr = splitFlex[1];
  }else{
    rtnStr = flex;
  }
  return rtnStr;
}

function cleanModal(str) {
	const idRegEx = /^(\d+\:)/;
	return str.replace(idRegEx,'');
}

function getPatternMap(pattern, stickType){
    var patternmap;

    if(stickType === 'sticks'){
    	switch(pattern){
            case 'P92':
                patternmap = 'P92%7CP28%7CP92M';
                break;
            case 'P92M':
                patternmap = 'P92%7CP28%7CP92M';
                break;
            case 'P28':
                patternmap = 'P92%7CP28';
                break;
            case 'P88':
                patternmap = 'P88%7CP92';
                break;
            case 'P91A':
                patternmap = 'P91A%7CP92%7CP28%7CP92M';
                break;
            case 'P14':
                patternmap = 'P14%7CP92%7CP88';
                break;
            case 'P02':
                patternmap = 'P02%7CP92%7CP88';
                break;
            case 'PM9':
                patternmap = 'PM9%7CP88%7CP92';
                break;
            case '92M':
                patternmap = 'P92%7CP28%7CP92M';
                break;
	    }
    }else if(stickType === 'goalie'){
    	patternmap = 'P31';
    }
    return patternmap;
}

function getHandMap(hand){
    var handmap;
    if(hand === 'LFT'){
        handmap = 'Left';
    }else if(hand === 'RHT'){
        handmap = 'Right';
    }
    return handmap;
}

function getBreakageDisplay(key,val){
	let rtnStr = '';
	$('#' + key + ' option').each(function(){
		if($(this).val() == val){
			rtnStr = $(this).html();
		}
	});
	return rtnStr;
}

function getStickFamily(stickFamily, stickType){
    var stickfamilymap;

    if(!stickFamily) {
      stickFamily = ' ';
    }

    if(stickType === 'sticks'){
        stickfamilymap = toCamelCase(stickFamily);
        stickfamilymap = 'Sticks-' + stickfamilymap;
    }else if(stickType === 'goalie'){
        stickfamilymap = 'Goalie-Sticks';
    }

    return stickfamilymap;
}

function getPriceMap(stickprice, stickType){
    var pricemap;
    var price = parseInt(stickprice);

    if(stickType === 'sticks'){
    	if(price < 99.99){
            pricemap = 'pmin=0.00&pmax=120.99';
        }else if(price >= 99.99 && price < 150){
            pricemap = 'pmin=98.99&pmax=180.99';
        }else if(price >= 150 && price < 200){
            pricemap = 'pmin=148.99&pmax=230.99';
        }else if(price >= 200 && price < 250){
            pricemap = 'pmin=198.99&pmax=280.99';
        }else if(price >= 250 && price < 280){
            pricemap = 'pmin=248.99&pmax=300.99';
        }else if(price >= 280.00){
            pricemap = 'pmin=278.99&pmax=499.99';
        }
    }else if(stickType === 'goalie'){
    	if(price < 129){
            pricemap = 'pmin=0.00&pmax=129';
        }else if(price >= 129 && price < 215){
            pricemap = 'pmin=128.99&pmax=215';
        }else if(price >= 215){
            pricemap = 'pmin=214.99&pmax=499.99';
        }
    }

    return pricemap;
}

function checkAvailabilitorShowSubstitution(stickMap, stickName, flex, hand, pattern, sticktype){
    if('stickUPC' in stickMap){
      var productid = stickMap.stickUPC;
      var checkAvailabilityURL = appendParamsToUrl(window.Urls.getCustomProductAvailability, {productID: productid});
    } else {
      $('.js-originalstick-idmissing').removeClass('u-display-none');
      $('.c-form-row-split-loading.loading-results').css('display', 'none');
      disableAnotherReviewButton('#stickwarranty2');
      return false;
    }

    $('#dwfrm_stickwarranty_origproduct').val(productid);
    $.ajax({
        type: 'POST',
        url: checkAvailabilityURL,
        dataType: 'json'
    }).done(function(response){
        if(response.availability){
          $('.c-form-row-split-loading.loading-results').css('display', 'none');
        	var productDetails = response.productDescription + '@&@' + response.productImage;
          $('#dwfrm_stickwarranty_replaceproduct').val(productid);
          showStickImage(productDetails, 'originalStick');
        } else {
        	showSubstitudeOption(response, flex, hand, pattern, stickMap, sticktype, stickName);
        }
    });
}

function initCheckProductAvailability(){
    var modelNumber = $('select[name$="_modelnumber"]').val();
    modelNumber = modelNumber.split(':');
    var flexValue = $('select[name$="_stickFlex"]').val();
    flexValue = flexValue.split(':');
    var handVariation = $('select[name$="_handVariation"]').val();
    var stickPattern = $('select[name$="_stickPattern"]').val();
    var productType = $('select[name$="_productType"]').val();

    if((handVariation !== '') && (stickPattern !== '')){
    	$('.c-form-row-split-loading.loading-results').css('display', 'flex');
        var stickModelFlexPatternURL = window.Urls.stickModelFlexPattern + '?productVariantId=' + flexValue[0] + '&stickProperty=handPattern' + '&handVariation=' + handVariation + '&pattern=' + stickPattern;
        $.ajax({
            type: 'POST',
            url: stickModelFlexPatternURL,
            dataType : 'json'
        }).done(function (response){
        	if(response.statusCode === 200) {
            	checkAvailabilitorShowSubstitution(response, modelNumber[1], flexValue[1], handVariation, stickPattern, productType);
            }
        });
    }
}

function showStickImage(stickImage, stick){
    var andIndex = stickImage.indexOf('@&@'),
        splitStickImage;
    if(andIndex >= 0){
    	splitStickImage = stickImage.split('@&@');
    }

    switch(stick){
        case 'originalStick':
            if ($('.js-stick-variationid').hasClass('u-display-none')) {
                $('.js-stick-variationid').removeClass('u-display-none');
            }

            if ($('.js-stick-image').hasClass('u-display-none')) {
            	$('.stick-warranty-image').attr('src', splitStickImage[1]);
                var stickDes = $('<span class="stick-description">' + splitStickImage[0] + '</span>');
                stickDes.appendTo('.js-stick-image');
                $('.js-stick-image').removeClass('u-display-none');
                $('.stick-warranty-image').css('display', 'flex');
            }
            break;
        case 'substitudeStick':
            var substituteStickValue = $('select[name$="_substituteoptions"]').val();
            if(substituteStickValue === ""){
                $('.stick-warranty-image').attr('src', '');
                $('#dwfrm_stickwarranty_replaceproduct').val('');
            }else{
            	if(andIndex >= 0){
                var prodIDs = splitStickImage[0].split(':'),
                  newProdID = prodIDs[2],
                  newProdDesc = prodIDs[3];
                $('#dwfrm_stickwarranty_replaceproduct').val(newProdID);
                $('#dwfrm_stickwarranty_replaceproductdesc').val(newProdDesc);
            		$('.stick-warranty-image').css('display', 'flex');
            		$('.stick-warranty-image').attr('src', splitStickImage[2]);
                    var stickDesSub = $('<span class="stick-description">' + splitStickImage[1] + '</span>');
                    stickDesSub.appendTo('.js-stick-image');
            	}else{
            		$('.stick-warranty-image').attr('src', '');
            		$('.stick-warranty-image').css('display', 'none');
                $('#dwfrm_stickwarranty_replaceproduct').val('');
            		showSubstituteText();
            	}
            }

            if ($('.js-stick-image').hasClass('u-display-none')) {
                $('.js-stick-image').removeClass('u-display-none');
            }
            break;
    }
}

function showSubstituteText(){
    var substituteValue = $('select[name$="_substituteoptions"] option:selected').val();
    var substituteText = $('select[name$="_substituteoptions"] option:selected').text();
    var stickDesSub;

    if((substituteValue.indexOf('contactcustomerservice')) >= 0){
        stickDesSub = $('<span class="stick-description">' + window.Resources.NO_SUBSTITUTE_STICK_FIND + ' ' + window.Resources.ANOTHER_SUBSTITUTE_STICK + '</span>');
        stickDesSub.appendTo('.js-stick-image');
        disableAnotherReviewButton('#stickwarranty2');
    }else if((substituteValue.indexOf('nosuboption')) >= 0){
        var splitValue = substituteValue.split(':');
        $('#dwfrm_stickwarranty_replaceproduct').val('688698500400');
        $('#dwfrm_stickwarranty_replaceproductdesc').val(substituteText);
        stickDesSub = $('<span class="stick-description">' + splitValue[2] + '</span>');
        stickDesSub.appendTo('.js-stick-image');
    }else{
        stickDesSub = $('<span class="stick-description">' + substituteText + '</span>');
        stickDesSub.appendTo('.js-stick-image');
    }
}

function toCamelCase(str) {
    str = str.toLowerCase();
    str = str.replace(/^./, str[0].toUpperCase());
    return str;
}

function showSubOptions(stickValues, substitudeOptionField, originalStickDetails, substituteOptionsAvailable){
    if('futureLaunchUPC' in stickValues && stickValues.futureLaunchUPC && (stickValues.futureLaunchUPC.indexOf('not') < 0) && stickValues.futureLaunchUPC !== '' && stickValues.futureLaunchUPC !== '0'){
        substituteOptionsAvailable = true;
        substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.STICK_WAIT_NEW_LAUNCH + ' (' + stickValues.futureLaunchName + ' - ' + stickValues.futureLaunchDescription + ')" value="newlaunch:' + originalStickDetails.productID + ':' + stickValues.futureLaunchUPC + ':' + stickValues.futureLaunchName + ':' + stickValues.futureLaunchDescription + ':' + stickValues.futureLaunchDate + '"> ' + window.Resources.STICK_WAIT_NEW_LAUNCH + ' (' + stickValues.futureLaunchName + ' - ' + stickValues.futureLaunchDescription + ') </option>');
    }

    if(!substituteOptionsAvailable){
        if (isRetailer()){
            substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.RETAILER_CREDIT_LABEL + ' " value="nosuboption:' + originalStickDetails.productID + ':' + window.Resources.NO_SUBSTITUTE_RETAILER_MSG + '"> ' + window.Resources.RETAILER_CREDIT_LABEL + ' </option>');
        } else {
          // Removes all children except the first one (Select...)
          substitudeOptionField.children(':gt(0)').remove();
          substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.STICK_NO_SUB_LABEL_VALUE + '" value="nosuboption:' + originalStickDetails.productID + ':' + window.Resources.NO_SUBSTITUTE_CONSUMER_MSG + '"> ' + window.Resources.STICK_NO_SUB_LABEL_VALUE + ' </option>');
        }
    }
    $('.c-form-row-split-loading.loading-results').css('display', 'none');
    $('#stick-substitute-error-msg').css('display', 'none');
    $('#stick-substitute-error-msg').empty();
    if ($('.js-substitute-option').hasClass('u-display-none')) {
        $('.js-substitute-option').removeClass('u-display-none');
    }
}

function showSubstitudeOption(originalStickDetails, flex, hand, pattern, stickValues, stickType, stickname){
    var substitudeOptionField = $('select[name*="_substituteoptions"]');
    substitudeOptionField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
    var substituteOptionsAvailable = false;

    if('isBackOrder' in stickValues && stickValues.isBackOrder === '1'){
    	substituteOptionsAvailable = true;
    	if('productName' in originalStickDetails){
    		if(stickType === 'sticks'){
    			substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + originalStickDetails.productName + ' - ' + window.Resources.STICK_FLEX_LABEL + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')" value="backorder:' + originalStickDetails.productID + '@&@' + originalStickDetails.productDescription + '@&@' + originalStickDetails.productImage +'"> ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + originalStickDetails.productName + ' - ' + window.Resources.STICK_FLEX_LABEL + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')</option>');
    		}else if(stickType === 'goalie'){
    			substitudeOptionField.append('<option class="select-option" label=" '+  window.Resources.STOCK_STICK_BACK_ORDER+ ' (' + originalStickDetails.productName + ' - ' + window.Resources.STICK_PADDLE_SIZE + flex + ' '+ window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')" value="backorder:' + originalStickDetails.productID + '@&@' + originalStickDetails.productDescription + '@&@' + originalStickDetails.productImage +'"> ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + originalStickDetails.productName + ' - ' + window.Resources.STICK_PADDLE_SIZE + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')</option>');
    		}
    	}else{
    		if(stickType === 'sticks'){
    			substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + stickname + ' - ' + window.Resources.STICK_FLEX_LABEL + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')" value="backorder:' + originalStickDetails.productID + '"> ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + stickname + ' - ' + window.Resources.STICK_FLEX_LABEL + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ') </option>');
    		}else if(stickType === 'goalie'){
    			substitudeOptionField.append('<option class="select-option" label=" ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + stickname + ' - ' + window.Resources.STICK_PADDLE_SIZE + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ')" value="backorder:' + originalStickDetails.productID + '"> ' + window.Resources.STOCK_STICK_BACK_ORDER + ' (' + stickname + ' - ' + window.Resources.STICK_PADDLE_SIZE + flex + ' ' + window.Resources.STICK_HAND_LABEL + hand + ' ' + window.Resources.STICK_PATTERN_LABEL + pattern + ') </option>');
    		}
    	}
    }

    if('stickPrice' in stickValues && 'stickFamily' in stickValues){
        var flexMap = getFlexMap(flex, stickType);
        var patternMap = getPatternMap(pattern, stickType);
        var handMap = getHandMap(hand);
        var priceMap, stickFamily, prefn1;
        priceMap = getPriceMap(stickValues.stickPrice, stickType);
        stickFamily = getStickFamily(stickValues.stickFamily, stickType);

        if(stickType === 'sticks'){
            prefn1 = 'flex';
        }else if(stickType === 'goalie'){
            prefn1 = 'size';
        }

        var substituteOptionsURL = window.Urls.stickSubstituteOptions + '?cgid=' + stickFamily + '&' + priceMap + '&prefn1=' + prefn1 + '&prefv1=' + flexMap +'&prefn2=pattern&prefv2=' + patternMap + '&hand=' + handMap + '&stickType=' + stickType + '&stickUPC=' + originalStickDetails.productID;

        $.ajax({
        	type: 'POST',
        	url: substituteOptionsURL,
        	dataType: 'json'
        }).done(function(response){
          sessionStorage.setItem('productError', 'false');
        	if(response.substituteOptionsAvailable){
        		substituteOptionsAvailable = true;
        		var substituteOptions = response.availableSubstituteStickJSON;
        		for(var j=0;j<substituteOptions.availableStickDetails.length;j++){
        			if(substituteOptions.availableStickDetails[j].stickFlex != null){
        			    if(substituteOptions.availableStickDetails[j].stickColor != null){
        			    	substitudeOptionField.append('<option class="select-option" label="' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_FLEX_LABEL + substituteOptions.availableStickDetails[j].stickFlex + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + ' ' + window.Resources.STICK_COLOR_LABEL + substituteOptions.availableStickDetails[j].stickColor + '" value="substitute:' + originalStickDetails.productID + ':' + substituteOptions.availableStickDetails[j].stickID + ':' + substituteOptions.availableStickDetails[j].stickName + ':' + substituteOptions.availableStickDetails[j].stickFlex + ':' + substituteOptions.availableStickDetails[j].stickHand + ':' + substituteOptions.availableStickDetails[j].stickPattern + ':' + substituteOptions.availableStickDetails[j].stickColor + '@&@' + substituteOptions.availableStickDetails[j].stickDescription + '@&@' + substituteOptions.availableStickDetails[j].stickImage + '">' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_FLEX_LABEL + substituteOptions.availableStickDetails[j].stickFlex + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + ' ' + window.Resources.STICK_COLOR_LABEL + substituteOptions.availableStickDetails[j].stickColor + '</option>');
        			    }else{
        			    	substitudeOptionField.append('<option class="select-option" label="' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_FLEX_LABEL + substituteOptions.availableStickDetails[j].stickFlex + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '" value="substitute:' + originalStickDetails.productID + ':' + substituteOptions.availableStickDetails[j].stickID + ':' + substituteOptions.availableStickDetails[j].stickName + ':' + substituteOptions.availableStickDetails[j].stickFlex + ':' + substituteOptions.availableStickDetails[j].stickHand + ':' + substituteOptions.availableStickDetails[j].stickPattern + '@&@' + substituteOptions.availableStickDetails[j].stickDescription + '@&@' + substituteOptions.availableStickDetails[j].stickImage + '">' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_FLEX_LABEL + substituteOptions.availableStickDetails[j].stickFlex + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '</option>');
        			    }
        			} else if (substituteOptions.availableStickDetails[j].stickSize != null){
        				if(substituteOptions.availableStickDetails[j].stickColor != null){
        			    	substitudeOptionField.append('<option class="select-option" label="' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_PADDLE_SIZE + substituteOptions.availableStickDetails[j].stickSize + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + ' ' + window.Resources.STICK_COLOR_LABEL + substituteOptions.availableStickDetails[j].stickColor + '" value="substitute:' + originalStickDetails.productID + ':' + substituteOptions.availableStickDetails[j].stickID + ':' + substituteOptions.availableStickDetails[j].stickName + ':' + substituteOptions.availableStickDetails[j].stickSize + ':' + substituteOptions.availableStickDetails[j].stickHand + ':' + substituteOptions.availableStickDetails[j].stickPattern + ':' + substituteOptions.availableStickDetails[j].stickColor + '@&@' + substituteOptions.availableStickDetails[j].stickDescription + '@&@' + substituteOptions.availableStickDetails[j].stickImage + '">' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_PADDLE_SIZE + substituteOptions.availableStickDetails[j].stickSize + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + ' ' + window.Resources.STICK_COLOR_LABEL + substituteOptions.availableStickDetails[j].stickColor + '</option>');
        			    }else{
        			    	substitudeOptionField.append('<option class="select-option" label="' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_PADDLE_SIZE + ':' + substituteOptions.availableStickDetails[j].stickSize + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '" value="substitute:' + originalStickDetails.productID + ':' + substituteOptions.availableStickDetails[j].stickID + ':' + substituteOptions.availableStickDetails[j].stickName + ':' + substituteOptions.availableStickDetails[j].stickSize + ':' + substituteOptions.availableStickDetails[j].stickHand + ':' + substituteOptions.availableStickDetails[j].stickPattern + '@&@' + substituteOptions.availableStickDetails[j].stickDescription + '@&@' + substituteOptions.availableStickDetails[j].stickImage + '">' + substituteOptions.availableStickDetails[j].stickName + '- ' + window.Resources.STICK_PADDLE_SIZE + ':' + substituteOptions.availableStickDetails[j].stickSize + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '</option>');
        			    }
              }else{
                substitudeOptionField.append('<option class="select-option" label="' + substituteOptions.availableStickDetails[j].stickName + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '" value="substitute:' + originalStickDetails.productID + ':' + substituteOptions.availableStickDetails[j].stickID + ':' + substituteOptions.availableStickDetails[j].stickName + ':' + substituteOptions.availableStickDetails[j].stickFlex + ':' + substituteOptions.availableStickDetails[j].stickHand + ':' + substituteOptions.availableStickDetails[j].stickPattern + '@&@' + substituteOptions.availableStickDetails[j].stickDescription + '@&@' + substituteOptions.availableStickDetails[j].stickImage + '">' + substituteOptions.availableStickDetails[j].stickName + ' ' + window.Resources.STICK_HAND_LABEL + substituteOptions.availableStickDetails[j].stickHand + ' ' + window.Resources.STICK_PATTERN_LABEL + substituteOptions.availableStickDetails[j].stickPattern + '</option>');
              }
        		}
        	}
        	showSubOptions(stickValues, substitudeOptionField, originalStickDetails, substituteOptionsAvailable);
        }).fail(function() {
          sessionStorage.setItem('productError', 'true');
          if ($('.js-nostick-variationid').hasClass('u-display-none')) {
            $('.js-nostick-variationid').removeClass('u-display-none');
          }
          var tempForm = $('#stickwarranty2');
          $('.c-form-row-split-loading.loading-results').css('display', 'none');
          disableAnotherReviewButton(tempForm);
        });
    }else{
    	showSubOptions(stickValues, substitudeOptionField, originalStickDetails, substituteOptionsAvailable);
    }

}

function disableSubstitudeOptions(){
    if (!$('.js-stick-variationid').hasClass('u-display-none')) {
        $('.js-stick-variationid').addClass('u-display-none');
    }

    if (!$('.js-substitute-stick').hasClass('u-display-none')) {
        $('.js-substitute-stick').addClass('u-display-none');
    }

    if (!$('.js-nostick-variationid').hasClass('u-display-none')) {
        $('.js-nostick-variationid').addClass('u-display-none');
    }

    if (!$('.js-stick-image').hasClass('u-display-none')) {
        $('.stick-warranty-image').attr('src', '');
        $('.js-stick-image').addClass('u-display-none');
    }

    if (!$('.js-substitute-option').hasClass('u-display-none')) {
        $('.js-substitute-option').addClass('u-display-none');
    }

    $('#stick-substitute-error-msg').css('display', 'none');

    $('#stick-substitute-error-msg').empty();

    if($('.js-stick-image').find('span.stick-description')){
        $('span.stick-description').remove();
    }

    if(!$('.js-originalstick-idmissing').hasClass('u-display-none')) {
      $('.js-originalstick-idmissing').addClass('u-display-none');
  }

  if(!$('#stickwarranty2 .general-error-message').hasClass('u-display-none')) {
    $('#stickwarranty2 .general-error-message').addClass('u-display-none');
  }
}

//Custom Stick Serial Number block
function initCustomStick() {
    $('.custom-stick').find('input[type="text"]').on('change', function() {
    	$('#custom-serial-number-error-msg').css('display', 'none');
        var stickSerialNumber = $('.custom-stick').find('input[type="text"]').val();
        var stickDescription = $('.js-custom-stick-description').find('input');
        var stickPurchaseDate = $('.js-custom-stick-purchase').find('input');
        var customNumberRegExp1 = /^([a-zA-Z]{2,3}[0-9]{3,})$/g;
        var customNumberRegExp2 = /^([0-9]{7,12})$/g;
        disableAnotherReviewButton('#stickwarranty3');

        if(stickSerialNumber.match(customNumberRegExp1) || stickSerialNumber.match(customNumberRegExp2)) {
        	var duplicateStickWarranty = checkDuplicateWarranty(stickSerialNumber, '#custom-serial-number-error-msg');
        	if(!duplicateStickWarranty){
        		var customSticksDataURL = window.Urls.stickModelFlexPattern + '?serialNumber=' + stickSerialNumber + '&stickProperty=customSticks';
                $.ajax({
                    type: 'POST',
                    url: customSticksDataURL,
                    dataType: 'json'
                }).done (function (response){
                    if(response.statusCode === 200){
                        var parseMessage = JSON.parse(response.message);
                        if(parseMessage.Count >= 1) {
                            var data = parseMessage.Items[0];
                            stickDescription.each(function(){$(this).val(data.Description.S);});
                            stickPurchaseDate.each(function(){$(this).val(data.PurchaseDate.S);});
                            sessionStorage.setItem('serialNumberError', 'false');
                            enableAnotherReviewButton('#stickwarranty3');
                        } else {
                            stickDescription.each(function(){$(this).val('');});
                            stickPurchaseDate.each(function(){$(this).val('');});
                            $('#custom-serial-number-error-msg').css('display', 'block');
                            $("#custom-serial-number-error-msg").html( window.Resources.CUSTOM_STICK_NOT_FOUND_ERROR );
                            sessionStorage.setItem('serialNumberError', 'true');
                        }
                    }else if(response.statusCode === 410){
                    	$('#custom-serial-number-error-msg').css('display', 'block');
                        $("#custom-serial-number-error-msg").html( window.Resources.CUSTOM_STICK_EXPIRED_ERROR );
                        sessionStorage.setItem('serialNumberError', 'true');
                    }
                });
        	}
        } else{
            $('#custom-serial-number-error-msg').css('display', 'block');
            $("#custom-serial-number-error-msg").html(
                '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i>' + window.Resources.CUSTOM_STICK_ERROR + '</div>'
            );
            sessionStorage.setItem('serialNumberError', 'true');
        }
    });
}

//Standard Stick Serial Number block
function initStandardStick(){
    $('.standard-stick').find('input[type="text"]').on('change', function() {
    	$('#serial-number-error-msg').css('display', 'none');
        var stickSerialNumber = $('.standard-stick').find('input[type="text"]').val();
        var serialNumberRegExp = /^([tfsTFS]{1,}[0-9]{4,4}[-]{1,1}[0-9]{5,5})$/g;
        disableAnotherReviewButton('#stickwarranty2');

        if(stickSerialNumber.match(serialNumberRegExp)) {
        	var duplicateStickWarranty = checkDuplicateWarranty(stickSerialNumber, '#serial-number-error-msg');
        	if(!duplicateStickWarranty){
        		$('#serial-number-error-msg').css('display', 'none');
        		sessionStorage.setItem('serialNumberError', 'false');
        		enableAnotherReviewButton('#stickwarranty2');
        	}
        } else{
        	$('#serial-number-error-msg').css('display', 'block');
            $("#serial-number-error-msg").html(
			    '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i>' + window.Resources.STOCK_STICK_ERROR + '</div>'
            );
            sessionStorage.setItem('serialNumberError', 'true');
        }
    });
}

function checkDuplicateWarranty(stickNumber, className){
    var checkDuplicateWarrantyURL = window.Urls.stickModelFlexPattern + '?serialNumber=' + stickNumber + '&stickProperty=standardSticks';
    var duplicateWarranty = false;
    $.ajax({
        type: 'POST',
        url: checkDuplicateWarrantyURL,
        dataType: 'json'
    }).done (function (response){

        if(response.statusCode === 200){
            var parseMessage = JSON.parse(response.message);
            if(parseMessage.Count >= 1) {
            	$(className).css('display', 'block');
            	$(className).html( window.Resources.STICK_CLAIMED_ERROR_MSG );
                duplicateWarranty = true;
                sessionStorage.setItem('serialNumberError', 'true');
                disableAnotherReviewButton('#stickwarranty2');
            }
        }
    });
    return duplicateWarranty;
}

function showContentPopups() {
    $('.c-stick-warranty__popup-btn').on('click', function() {
        $('.c-stick-warranty__popup').toggle();
    });
    $('.c-stick-warranty__popup-close').on('click', function() {
        $('.c-stick-warranty__popup').toggle();
    });

    $('.c-stick-warranty__receipt-popup-btn').on('click', function() {
        $('.c-stick-warranty__receipt-popup').toggle();
    });
    $('.c-stick-warranty__receipt-popup-close').on('click', function() {
        $('.c-stick-warranty__receipt-popup').toggle();
    });

    $('.c-stick-warranty__serial-number-popup-btn').on('click', function() {
        $('.c-stick-warranty__serial-number-popup').toggle();
    });
    $('.c-stick-warranty__serial-number-popup-close').on('click', function() {
        $('.c-stick-warranty__serial-number-popup').toggle();
    });

    $('.c-stick-warranty__breakage-popup-btn').on('click', function() {
        $('.c-stick-warranty__breakage-popup').toggle();
    });
    $('.c-stick-warranty__breakage-popup-close').on('click', function() {
        $('.c-stick-warranty__breakage-popup').toggle();
    });
}

function populatePreview(input) {
    const inputID = $(input).attr('id')
      , selector = '#' + inputID + '-imagePreview'
      , storage = '#' + inputID + '-value';
    if (input.files && input.files[0]) {
        if(input.files[0].size > 500000 && input.files[0].size < 20000000) {
            var reader = new FileReader();
            reader.onload = function(e) {
                $(storage).val(e.target.result);
                $(selector).css('background-image', 'url('+e.target.result +')');
                $(selector).hide();
                $(selector).fadeIn(650);
            };
            reader.readAsDataURL(input.files[0]);
            if($(selector).hasClass("show-error")){
                $(selector).removeClass("show-error");
            }
        } else {
            $(selector).css('background-image', 'none');
            $(selector).addClass("show-error");
        }
    }

}


//populate store locations in state dropdown
function populateStateAddress(){
    if($('.js-stick-store-location').length > 0){
        $('.c-form-row-split-loading.loading-store').css('display', 'flex');
        var storeNameField = $('select[name*="_stickstorename"]');
        var storePinCode = $('input[name*="_storepostal"]').val();
        var storeCountryCode = $('input[name*="_storecountry"]').val();
        storeNameField.html('<option class="select-option" label="' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '" value="">' + window.Resources.STICK_WARRANTY_SELECT_LABEL + '</option>');
        var updateStateAddressURL = appendParamsToUrl(window.Urls.updateStateAddress, {storePinCode: storePinCode, storeCountryCode: storeCountryCode});

        $.ajax({
            type: 'POST',
            url: updateStateAddressURL,
            dataType: 'json'
        }).done(function(response){
            if(response.storecount > 0){
                if (!$('.js-stick-other-location').hasClass('u-display-none')) {
                    $('.js-stick-other-location').addClass('u-display-none');
                }
                var storeNames = response.stores;
                for(var i=0;i<response.storecount;i++){
                    storeNameField.append('<option class="select-option" label="' + storeNames.storeResult[i].storeName + ' - ' + storeNames.storeResult[i].storeAddress1 + ',' + storeNames.storeResult[i].city + ',' + storeNames.storeResult[i].stateCode + '" value="' + storeNames.storeResult[i].storeName + ' - ' + storeNames.storeResult[i].storeAddress1 + ',' + storeNames.storeResult[i].city + ',' + storeNames.storeResult[i].stateCode + '">' + storeNames.storeResult[i].storeName + ' - ' + storeNames.storeResult[i].storeAddress1 + ',' + storeNames.storeResult[i].city + ',' + storeNames.storeResult[i].stateCode + '</option>');
                }
                storeNameField.append('<option class="select-option" label="Other Store" value="otherstore"> Other Store </option>');
                if ($('.js-store-pincode').hasClass('u-display-none')) {
        	        $('.js-store-pincode').removeClass('u-display-none');
        	    }
            	if ($('.js-store-country').hasClass('u-display-none')) {
        	        $('.js-store-country').removeClass('u-display-none');
        	    }
            	if ($('.js-stick-store-location').hasClass('u-display-none')) {
                    $('.js-stick-store-location').removeClass('u-display-none');
                }
                $('.c-form-row-split-loading.loading-store').css('display', 'none');
            }else{
                if ($('.js-store-pincode').hasClass('u-display-none')) {
                  $('.js-store-pincode').removeClass('u-display-none');
                }
                if ($('.js-store-country').hasClass('u-display-none')) {
                    $('.js-store-country').removeClass('u-display-none');
                }
                if (!$('.js-stick-store-location').hasClass('u-display-none')) {
                    $('.js-stick-store-location').addClass('u-display-none');
                }
                if ($('.js-stick-other-location').hasClass('u-display-none')) {
                    $('.js-stick-other-location').removeClass('u-display-none');
                }
                $('.c-form-row-split-loading.loading-store').css('display', 'none');
            }
            $('.js-modeoforder').find('input[name*="_modeoforder"]').attr('disabled', false);
        });
    }
}

//toggle form elements for retailer and customer
function toggleFormElementes(){
    var retailerField = $('input[name$="_amiretailer"]:checked').val();

    switch(retailerField){
        case 'retailer':
        	if ($('.c-form-retailer').hasClass('hidden')) {
                $('.c-form-retailer').removeClass('hidden');
            }
        	if (!$('.c-form-not-retailer').hasClass('hidden')) {
                $('.c-form-not-retailer').addClass('hidden');
            }
        	if($('.retailer-error-msg').length > 0){
        		$('#stickwarranty').find('button[name*="_next"]').prop('disabled', true);
        	}
            break;
        case 'notretailer':
        	$('#stickwarranty').find('button[name*="_next"]').prop('disabled', false);
        	if ($('.c-form-not-retailer').hasClass('hidden')) {
                $('.c-form-not-retailer').removeClass('hidden');
            }
        	if (!$('.c-form-retailer').hasClass('hidden')) {
                $('.c-form-retailer').addClass('hidden');
            }
            // $('.c-stick-warranty__button button').prop('disabled', 'false');
            break;
    }
}

//Show error if user does not uploads the image
function checkImagesSelected(theForm){

  var displayNonediv = $(theForm).find('.file-upload .u-display-none');
  var receiptImagediv = $(theForm).find('.file-upload .receipt-img');
  var serialImagediv = $(theForm).find('.file-upload .serial-img');
  var brokenImagediv = $(theForm).find('.file-upload .broken-img');
  var classNameList, imageError = false, brokenImageFile = false, serialImageFile = false, receiptImageFile = false;

  if(displayNonediv.length > 0){
      for(var i=0;i<displayNonediv.length;i++){
          var className = displayNonediv[i].className;
          if(classNameList === undefined){
              classNameList = className + ',';
          }else if(i === (displayNonediv.length-1)){
              classNameList = classNameList + className;
          }else{
              classNameList = classNameList + className + ',';
          }
      }
  }

  if(classNameList == undefined){
    brokenImageFile = true;
    serialImageFile = true;
    receiptImageFile = true;
  }else if (classNameList !== undefined){
    if(classNameList.indexOf('broken-img') < 0){
      brokenImageFile = true;
    }
    if(classNameList.indexOf('receipt-img') < 0){
      receiptImageFile = true;
    }
    if(classNameList.indexOf('serial-img') < 0){
      serialImageFile = true;
    }
  }

  $.each($(theForm).serializeArray(), function(_, kv) {
    if(kv.name == 'stick-broken-img-standard-value' || kv.name == 'stick-broken-img-personal-value'){
      if(brokenImageFile && kv.value == ''){
        brokenImagediv.find('.stick-broken-img-error').css('display', 'block');
        brokenImagediv.find('.stick-broken-img-error').html(
          '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> ' + window.Resources.STICK_BREAKAGE_ERROR + ' </div>'
        );
        imageError = true;
      }else{
        brokenImagediv.find('.stick-broken-img-error').css('display', 'none');
        brokenImagediv.find('.stick-broken-img-error').html('');
      }
    }else if(kv.name == 'stick-receipt-img-value'){
      if(receiptImageFile && kv.value == ''){
        receiptImagediv.find('.stick-receipt-img-error').css('display', 'block');
        receiptImagediv.find('.stick-receipt-img-error').html(
          '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> ' + window.Resources.STICK_RECEIPT_ERROR + ' </div>'
        );
        imageError = true;
      }else{
        receiptImagediv.find('.stick-receipt-img-error').css('display', 'none');
        receiptImagediv.find(".stick-receipt-img-error").html('');
      }
    }else if(kv.name == 'stick-serial-img-standard-value' || kv.name == 'stick-serial-img-personal-value'){
      if(serialImageFile && kv.value == ''){
        serialImagediv.find('.stick-serial-img-error').css('display', 'block');
        serialImagediv.find('.stick-serial-img-error').html(
          '<div class="alert alert-error"><i class="fa fa-thumbs-up"></i> ' + window.Resources.STICK_SERIAL_ERROR + ' </div>'
        );
        imageError = true;
      }else{
        serialImagediv.find('.stick-serial-img-error').css('display', 'none');
        serialImagediv.find(".stick-serial-img-error").html('');
      }
    }
  });

  return imageError;
}

function populatePreviews(theForm) {
    //Reset all images
    $(theForm).find('.avatar-preview-child').each(function() {
        $(this).attr('style',null);
    });

    $(theForm).find('.stick-serial-img-input').change(function() {
        populatePreview(this);
    });

    $(theForm).find('.stick-receipt-img-input').change(function() {
        populatePreview(this);
    });

    $(theForm).find('.stick-broken-img-input').change(function() {
        populatePreview(this);
    });
}

// JS adapted from countries.js in SFCC code

function populateCountry() {
    var countrySelect = $('.js-country');
    if(countrySelect.is('[class*="js-country-code-"]')) {
        var countrySelectClasses = countrySelect.attr('class').split(' ');
        for(var i = 0; i < countrySelectClasses.length; i++) {
            var countryCode = '';
            if(countrySelectClasses[i].match(/country-code-/)) {
                countryCode = countrySelectClasses[i].split('-').pop();
                break;
            }
        }
        countrySelect
            .find('option')
            .not('[value="'+ countryCode +'"]')
            .remove();
    }
}

function populateStatesProvinces() {
    $('.js-country').find('select[name$="_country"]').on('load change', function() {
        var countries = window.Countries;
        var selection = $(this).val();
        var regions = countries[selection].regions;
        var reqString = '';

        // only add required indicator if field is mandatory in the xml
        if ($('label[for*="_state"]').find('.c-form-row__label-required').length > 0) {
            reqString = ' <span class="c-form-row__label-required">*</span>';
        }

        $('label[for*="_state"]').html(countries[selection].regionLabel + reqString);

        var stateField = $('select[name*="_state"]');
        stateField.html('<option class="select-option" label="Select..." value="">Select...</option>');

        Object.keys(regions).forEach(function(key) {
            stateField.append('<option class="select-option" label="' + regions[key] + '" value="' + key + '">' + regions[key] + '</option>');
        });

        if (selection === 'CA') {
            $('.postal').on('keyup', function(){
                var pcode = $(this).val().split(' ').join('');
                if (pcode.length > 0) {
                    pcode = pcode.match(new RegExp('.{1,3}', 'g')).join(' ');
                }
                $(this).val(pcode);
            });
        }

        // manual fix for military addresses since ViewHelpers.getFieldOptions won't allow duplicate keys
        var apo = '<option optionid="AE" label="Armed Forces Africa" value="AE"/><option optionid="AA" label="Armed Forces America (exc. Canada)" value="AA"/><option optionid="AE" label="Armed Forces Canada" value="AE"/><option optionid="AE" label="Armed Forces Europe" value="AE"/><option optionid="AE" label="Armed Forces Middle East" value="AE"/><option optionid="AP" label="Armed Forces Pacific" value="AP"/>';

        if (selection === 'US') {
            stateField.append(apo);
        }
    });
}

function initCountries() {
    populateCountry();
    populateStatesProvinces();
    if ($('.js-country').find('select[name$="_country"]').val()) {
        $('.js-country').find('select[name$="_country"]').trigger('change');
    }
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });

    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: window.Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });
}

function setTitle(showMe){
  switch (showMe){
   case 'review':
      if ($('.c-stick-warranty__review').hasClass('u-display-none')) {
        $('.c-stick-warranty__review').removeClass('u-display-none');
      }
      if (!$('.c-stick-warranty__copy').hasClass('u-display-none')) {
          $('.c-stick-warranty__copy').addClass('u-display-none');
      }
      if (!$('.c-stick-warranty__confirmation').hasClass('u-display-none')) {
          $('.c-stick-warranty__confirmation').addClass('u-display-none');
      }
      break;
   case 'confirmation':
      if ( !$('.c-stick-warranty__review').hasClass('u-display-none')) {
        $('.c-stick-warranty__review').addClass('u-display-none');
      }
      if (!$('.c-stick-warranty__copy').hasClass('u-display-none')) {
          $('.c-stick-warranty__copy').addClass('u-display-none');
      }
      if ($('.c-stick-warranty__confirmation').hasClass('u-display-none')) {
          $('.c-stick-warranty__confirmation').removeClass('u-display-none');
      }
      break;
    default:
      if ($('.c-stick-warranty__copy').hasClass('u-display-none')) {
        $('.c-stick-warranty__copy').removeClass('u-display-none');
      }
      if (!$('.c-stick-warranty__review').hasClass('u-display-none')) {
          $('.c-stick-warranty__review').addClass('u-display-none');
      }
      if (!$('.c-stick-warranty__confirmation').hasClass('u-display-none')) {
          $('.c-stick-warranty__confirmation').addClass('u-display-none');
      }
    }
  }

function populateReviewData(dataContainer,populateData,ind){
  let tbdDelivery = false;
  if(dataContainer.find('.c-stick-warranty__summary-row-label').length){
    let tempLabel = dataContainer.find('.c-stick-warranty__summary-row-label').html();
    tempLabel = tempLabel.replace('*ind*',ind + 1);
    if('dwfrm_stickwarranty_serialnumber' in populateData) {
      tempLabel = tempLabel.replace('*sn*',populateData['dwfrm_stickwarranty_serialnumber']);
      dataContainer.find('.c-stick-warranty__summary-row-label').html(tempLabel);
    } else {
      dataContainer.find('.c-stick-warranty__summary-row-label').addClass('u-display-none');
    }
  }
  dataContainer.find('.c-stick-warranty__summary-value').each(function(){
    let tempKeys = $(this).data('key');
    if(typeof tempKeys !== 'undefined' && tempKeys.length){
      let tempKeyArray = tempKeys.split('|'),
        dataSet = false;
      for(k=0;k<tempKeyArray.length;k++){
        let tempKey = tempKeyArray[k];
        if(tempKey in populateData && populateData[tempKey].length){
          let tempVal = populateData[tempKey];
          if(tempKey.indexOf('breakage') > -1) {
            tempVal = getBreakageDisplay(tempKey,tempVal)
          } else if(tempKey.indexOf('stickFlex') > -1) {
            tempVal = getFlexUnMap(tempVal)
          } else if(tempKey.indexOf('handVariation') > -1) {
            tempVal = getHandMap(tempVal)
          } else if(tempKey.indexOf('modelnumber') > -1) {
            tempVal = cleanModal(tempVal)
          }
          if ($(this).hasClass('u-display-none')) {
            $(this).removeClass('u-display-none');
          }
          $(this).html(tempVal);
          dataSet = true;
          break;
        }
      }
      if(!dataSet) {
        $(this).closest('.c-stick-warranty__summary-row, .c-stick-warranty__summary-row-split').addClass('u-display-none');
      }
    }
  });
  //Special Overrides
  if('dwfrm_stickwarranty_modelnumber' in populateData && populateData['dwfrm_stickwarranty_modelnumber'] == 'contactcustomerservice'){
    let isGoalie = (populateData['dwfrm_stickwarranty_productType'].toLowerCase() == 'goalie');
    dataContainer.find('.c-stick-warranty__summary-stick-name .c-stick-warranty__summary-value').html((isGoalie ? 'Goalie' : 'Player') + ' ' + window.Resources.STICK_TBD);
    tbdDelivery = true;
  }
  if('dwfrm_stickwarranty_replaceproduct' in populateData && populateData['dwfrm_stickwarranty_replaceproduct'] == 'nosuboption'){
    tbdDelivery = true;
  }


  if(tbdDelivery){
    dataContainer.find('.c-stick-warranty__summary-row-customer-service-message').removeClass('u-display-none');
  } else {
    dataContainer.find('.c-stick-warranty__summary-row-delivery-message').removeClass('u-display-none');
  }
}

function generateReview(){
  const customerContainer = $('#stickwarrantyReviewCustomer'),
    personalStickContainer = $('#stickwarrantyReviewPersonalStick'),
    standardStickContainer = $('#stickwarrantyReviewStandardStick');

  //Reset Everything
  if (!personalStickContainer.hasClass('u-display-none')) {
    personalStickContainer.addClass('u-display-none').children('.c-stick-warranty__summary-stick-holder').html('');
  }
  if (!standardStickContainer.hasClass('u-display-none')) {
    standardStickContainer.addClass('u-display-none').children('.c-stick-warranty__summary-stick-holder').html('');
  }

  //Populate Customer Data
  populateReviewData(customerContainer,window.StickWarranty.customerInfo,0);

  //Populate Personal Stick Data
  if(window.StickWarranty.personalStickArray.length){
    const stickHolder = personalStickContainer.children('.c-stick-warranty__summary-stick-holder');
    personalStickContainer.removeClass('u-display-none');
    for(var i=0; i<window.StickWarranty.personalStickArray.length; i++ ) {
      const clone = personalTemplate.content.cloneNode(true);
      stickHolder.append(clone);
      populateReviewData(stickHolder.children().last(),window.StickWarranty.personalStickArray[i],i);
    }
  }

  //Populate Standard Stick Data
  if(window.StickWarranty.standardStickArray.length){
    const stickHolder = standardStickContainer.children('.c-stick-warranty__summary-stick-holder');
    standardStickContainer.removeClass('u-display-none');
    for(var i=0; i<window.StickWarranty.standardStickArray.length; i++ ) {
      const clone = standardTemplate.content.cloneNode(true);
      stickHolder.append(clone);
      populateReviewData(stickHolder.children().last(),window.StickWarranty.standardStickArray[i],i);
    }
  }
}

function navigateForms(loc){
  switch(loc){
    case 'home':
    case 'previous':
      setTitle('default');
      $('#stickwarranty2').hide();
      $('#stickwarranty3').hide();
      $('#stickwarrantyReview').hide();
      if (!$('.c-form-retailer').hasClass('hidden')) {
          $('.c-form-sticktype input:radio').prop('checked',false);
          $('.c-form-retailer').addClass('hidden');
      }
      if (!$('.c-form-not-retailer').hasClass('hidden')) {
          $('.c-form-not-retailer').addClass('hidden');
      }
      if(loc != 'previous' && window.StickWarranty.customerInfo.valid){
        if (!$('.js-amiretailer').hasClass('hidden')) {
            $('.js-amiretailer').addClass('hidden');
        }
        $('.c-form-sticktype input:radio').prop('checked',false);
      } else {
        if ($('.js-amiretailer').hasClass('hidden')) {
          $('.js-amiretailer').removeClass('hidden');
        }
      }
      $('#stickwarranty').show();
      break;
    case 'standard-stick':
      setTitle('default');
      $('#stickwarranty').hide();
      $('#stickwarranty3').hide();
      $('#stickwarrantyReview').hide();
      if(isRetailer()) {
        orderModeDisplay('retailer');
      } else {
        orderModeDisplay('clear');
      }
      $('#stickwarranty2').show().find('input:first').focus();
      populatePreviews($('#stickwarranty2'));
      break;
    case 'personalized-stick':
      setTitle('default');
      $('#stickwarranty').hide();
      $('#stickwarranty2').hide();
      $('#stickwarrantyReview').hide();
      $('#stickwarranty3').show().find('input:first').focus();
      populatePreviews($('#stickwarranty3'));
      break;
    case 'review':
      setTitle('review');
      $('#stickwarranty').hide();
      $('#stickwarranty2').hide();
      $('#stickwarranty3').hide();
      generateReview();
      $('#stickwarrantyReview').show();
      break;
    case 'confirmation':
      setTitle('confirmation');
      $('#stickwarranty').hide();
      $('#stickwarranty2').hide();
      $('#stickwarranty3').hide();
      $('#stickwarrantyReview').show().find('.c-stick-warranty__button').hide();

      break;
    case 'resubmithome':
      setTitle('Resubmit Images');
      $('#stickwarrantyreesubmit').show();
      $('#warrantyresubmitconfirmation').hide();
      break;
    case 'resubmitconfirmation':
      setTitle('Resubmit Images Confirmation');
      $('#stickwarrantyreesubmit').hide();
      $('#warrantyresubmitconfirmation').show();
      break;
    default:
      console.log('Bad Nav');
  }
  //Scroll to top
  $('html, body').stop().animate({
      'scrollTop': $('#primary').offset().top - $('.header-wrapper').height()
  }, 800);
}

function processImageUploads(stickArr, orderID, resubmission){
  const imgKeys = [{key: 'stick-receipt-img-value', kind:'receipt'},{key: 'stick-serial-img-standard-value', kind:'serialNumber'},{key: 'stick-broken-img-standard-value', kind:'brokenArea'},{key: 'stick-serial-img-personal-value', kind:'serialNumber'},{key: 'stick-broken-img-personal-value', kind:'brokenArea'}];
  let uploadPromises = [];

  stickArr.forEach(stick => {
    imgKeys.forEach(key => {
    if(key.key in stick && stick[key.key].length){
      let tempFile = stick[key.key],
      tempExt = getImageExtension(tempFile),
      imgData = {
        'stick-serial-no': stick.dwfrm_stickwarranty_serialnumber,
        'image-kind': key.kind,
        'image-extension': tempExt,
        'order-number': orderID,
        'resubmission': resubmission
      },
      imgPromise = $.Deferred();
      uploadPromises.push(imgPromise.promise());
      $.ajax({
        type: 'POST',
        url: window.Urls.imageUpload,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(imgData)
      }).done(function(response){
        //Parse Response
        let tempURL = response['url'],
        tempData = response['fields'],
        cleanString = 'data:image/' + tempExt + ';base64,',
        b64File = tempFile.replace(cleanString,'');

        tempData.file = b64toBlob(b64File, 'image/' + tempExt);

        let frmData = new FormData();
        for(key in tempData){
          frmData.append(key,tempData[key]);
        }

        $.ajax({
          type: 'POST',
          url: tempURL,
          data: frmData,
          processData: false,
          contentType: false
        }).done(function(){
          imgPromise.resolve(true);   
        }).fail(function(){
          imgPromise.reject(false);
        });
      });
    }
    });
  });

  return uploadPromises;
}

function getImageExtension(fileStr){
  const extRegEx = /data:image\/([A-Z]{3,4})\;/i;
  let rtnExt = false;

  rtnExt = fileStr.match(extRegEx);
  if(rtnExt.length > 0){
    return rtnExt[1];
  }else {
    return false;
  }
}

function b64toBlob (b64Data, contentType='', sliceSize=512) {
  //TY Jeremy/Peter Mortensen https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}

function processReturn() {
  let subResult = {isSuccess: true, subPromises: []};

  manageError(false,'');

  if(window.StickWarranty.personalStickArray.length === 0 && window.StickWarranty.standardStickArray.length === 0){
    manageError(true,window.Resources.NO_STICK_ERROR);
    return false;
  }

  //Verify there is an origional product id on all sticks
  if(window.StickWarranty.standardStickArray.length > 0){
    for(const stick of window.StickWarranty.standardStickArray) {
      if(!(stick.dwfrm_stickwarranty_origproduct && stick.dwfrm_stickwarranty_origproduct.length > 0)) {
        manageError(true,window.Resources.NO_STICK_ERROR);
        return false;
      }
    }
  }

  //Verify stick serial numbers for all sticks
  if(window.StickWarranty.personalStickArray.length > 0){
    var customNumberRegExp1 = /^([a-zA-Z]{1,}[0-9]{5,6})$/g;
    var customNumberRegExp2 = /^([0-9]{7,9})$/g;
    for(const stick of window.StickWarranty.personalStickArray) {
      serialNumber = stick.dwfrm_stickwarranty_serialnumber;
      if(serialNumber.match(customNumberRegExp1) || serialNumber.match(customNumberRegExp2)) {
        manageError(false,'');
      } else {
        manageError(true,window.Resources.SUBMISSION_FAIL);
        return false;
      }
    }
  }
  if(window.StickWarranty.standardStickArray.length > 0){
    var serialNumberRegExp = /^([tfsTFS]{1,}[0-9]{4,4}[-]{1,1}[0-9]{5,5})$/g;
    for(const stick of window.StickWarranty.standardStickArray) {
      serialNumber = stick.dwfrm_stickwarranty_serialnumber;
      if(!serialNumber.match(serialNumberRegExp)){
        manageError(true,window.Resources.SUBMISSION_FAIL);
        return false;
      }
    }
  }

  displayOverlay('#stickwarrantyReview',true);

  if(window.StickWarranty.personalStickArray.length){
    let tempResult = createReturn(window.StickWarranty.personalStickArray,true);
    if(!tempResult.isSuccess) subResult.isSuccess = false;
    subResult.subPromises.push(tempResult.theDefer);
  }
  if (window.StickWarranty.standardStickArray.length){
    let tempResult = createReturn(window.StickWarranty.standardStickArray,false);
    if(!tempResult.isSuccess) subResult.isSuccess = false;
    subResult.subPromises.push(tempResult.theDefer);
  }

  $.when.apply($, subResult.subPromises).then(function(){
    if(subResult.isSuccess){
      //Reset everything
      initWarrantyWindowVar();
      $('.c-stick-warranty__container form').each(function(){
        $(this).trigger('reset');
      });

      //Change Display
      displayOverlay('#stickwarrantyReview',false);
      $('.c-stick-warranty-submit').prop('disabled', false);
      navigateForms('confirmation');
    } else {
      manageError(true);
      $('.c-stick-warranty-submit').prop('disabled', false);
    }
    displayOverlay('#stickwarrantyReview',false);
  }).catch(function(){
    displayOverlay('#stickwarrantyReview',false);
    manageError(true,window.Resources.IMAGE_SUBMISSION_FAIL);
    $('.error-message').css('display', 'block');  
  });
}

function createReturn(stickArr,isCustom) {
  let orderID = 0,
    orderData = {'stick-serial-no': stickArr[0].dwfrm_stickwarranty_serialnumber},
    rtnObj = {'isSuccess': true, 'theDefer': $.Deferred()};

  $.ajax({
    type: 'POST',
    url: window.Urls.getOrderID,
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify(orderData)
  }).done(function(response){
      orderID = String(response['order-number']);
	    imgPromise = processImageUploads(stickArr,orderID, resubmission = false);
      $.when.apply($, imgPromise).then(() => {
        rtnObj.theDefer.resolve(submitWarrantyClaim(orderID,isCustom,stickArr));
      }).catch(() => {
        rtnObj.isSuccess = false;
        rtnObj.theDefer.reject(false);  
      });
  }).fail(function(){
    manageError(true,window.Resources.SUBMISSION_FAIL);
  });

  return rtnObj;
}

function submitWarrantyClaim(orderID,isCustom,stickArr){
	let claimData = {order: {}},
		isRetailerBool = isRetailer(),
    lineItems = [];

  stickArr.forEach(stick => {
    let tempObj = generateSubmissionStickObject(stick,isCustom);
    lineItems.push(tempObj);
  });

	claimData.order['order-number'] = orderID;
	claimData.order['order-date'] = Date.now();
	claimData.order['retailer-order'] = isRetailerBool;
	claimData.order['is-custom'] = isCustom;
	claimData.order['customer'] = generateSubmissionCustomerObject(isRetailerBool);
	claimData.order['image-upload-required'] = true;
	claimData.order['product-line-items'] = lineItems;

  $.ajax({
    type: 'POST',
    url: window.Urls.submitClaim,
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify(claimData)
  }).done(function(response){

    if('claim-number' in response){
      //Add Claim Number
      const claimContainer = (isCustom ? $('#stickwarrantyReviewPersonalStick') : $('#stickwarrantyReviewStandardStick'));
      claimContainer.find('.c-stick-warranty__summary-claim .c-stick-warranty__summary-value').html(response['claim-number']);
      claimContainer.find('.c-stick-warranty__summary-claim').removeClass('u-display-none');
    } else if ('error' in response) {
      manageError(true,response['error']);
    } else {
      manageError(true);
    }
  }).fail(function(){
    manageError(true);
  });
}

function generateSubmissionCustomerObject(isRetail) {
	let returnObj = {};

	if(isRetail) {
		returnObj["customer-email"] = window.StickWarranty.customerInfo.dwfrm_stickwarranty_retaileremail;
		returnObj["customer-shipToID"] = window.StickWarranty.customerInfo.dwfrm_stickwarranty_shipto;
		returnObj["shipping-address"] = {"country-code": window.StickWarranty.customerInfo.dwfrm_stickwarranty_shipto_country};
	} else {
		returnObj["customer-name"] = window.StickWarranty.customerInfo.dwfrm_stickwarranty_firstname + ' ' + window.StickWarranty.customerInfo.dwfrm_stickwarranty_lastname;
		returnObj["customer-email"] = window.StickWarranty.customerInfo.dwfrm_stickwarranty_email;
		returnObj["shipping-address"] = {
			"first-name": window.StickWarranty.customerInfo.dwfrm_stickwarranty_firstname,
			"last-name": window.StickWarranty.customerInfo.dwfrm_stickwarranty_lastname,
			"address1": window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_address1,
			"city": window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_city,
			"postal-code": window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_postal,
			"state-code": window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_states_state,
			"country-code": window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_country,
			"phone": window.StickWarranty.customerInfo.dwfrm_stickwarranty_phone,
			};
		if(window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_address2.length){
			returnObj["shipping-address"]['address2'] = window.StickWarranty.customerInfo.dwfrm_stickwarranty_address_address2;
		}

	}
	return returnObj;
}

function generateSubmissionStickObject(stick,isPersonal){
	let returnObj = {}
		, isGoalie = (stick.dwfrm_stickwarranty_productType.toLowerCase() == 'goalie');

	returnObj["is-custom"] = (isPersonal);
	returnObj["product-type"] = (isGoalie ? 'GOALIE' : 'STICK');
	returnObj["stick-serial-no"] = stick.dwfrm_stickwarranty_serialnumber;
	returnObj["breakage-point"] = (isGoalie ? stick.dwfrm_stickwarranty_goaliebreakagepoint : stick.dwfrm_stickwarranty_stickbreakagepoint);
	returnObj["breakage-type"] = (isGoalie ? stick.dwfrm_stickwarranty_goaliebreakagetype : stick.dwfrm_stickwarranty_stickbreakagetype);


	if(isPersonal){
		returnObj["purchase-date"] = stick.dwfrm_stickwarranty_stickdateofpurchased;
		returnObj["stick-description"] = stick.dwfrm_stickwarranty_description;
	} else {
		returnObj["original-product-id"] = stick.dwfrm_stickwarranty_origproduct;
		returnObj["is-backorder"] = false;
		returnObj["is-newlaunch"] = false;
		returnObj["original-stick-flex"] = stick.dwfrm_stickwarranty_stickFlex;
		returnObj["hand-variation"] = stick.dwfrm_stickwarranty_handVariation;
		returnObj["stick-pattern"] = stick.dwfrm_stickwarranty_stickPattern;
    returnObj["origional-product-id"] = stick.dwfrm_stickwarranty_origproduct;
    returnObj["original-stick-modelnumber"] = stick.dwfrm_stickwarranty_modelnumber;
    returnObj["delivery-message"] = window.Resources.DELIVERY_MESSAGE;
    if(stick.dwfrm_stickwarranty_replaceproduct.length > 0){
		  returnObj["replacement-product-id"] = stick.dwfrm_stickwarranty_replaceproduct;
		  returnObj["replacement-product-desc"] = stick.dwfrm_stickwarranty_replaceproduct;
    } else {
		  returnObj["replacement-product-id"] = stick.dwfrm_stickwarranty_substituteoptions.replace(/[^\d]/g, '');;
		  returnObj["replacement-product-desc"] = stick.dwfrm_stickwarranty_substitutelabel;
    }
		if(stick.dwfrm_stickwarranty_ordernumber){
			returnObj["is-storeorder"] = false;
			returnObj["is-onlineorder"] = true;
			returnObj["online-order"] = stick.dwfrm_stickwarranty_ordernumber;
			returnObj["online-order-date"] = stick.dwfrm_stickwarranty_orderdate;
		} else {
			returnObj["is-storeorder"] = true;
			returnObj["is-onlineorder"] = false;
      returnObj["purchase-date"] = stick.dwfrm_stickwarranty_stickdateofpurchased;
      if(stick.dwfrm_stickwarranty_stickotherstorename.length){
        returnObj["purchase-location"] = stick.dwfrm_stickwarranty_stickotherstorename;
      } else {
        returnObj["purchase-location"] = stick.dwfrm_stickwarranty_stickstorename;
      }
		}
	}
	return returnObj;
}

// Initialize resubmit photos form
function initresubmitform() {
  navigateForms('resubmithome');
  if ($('#stickwarrantyreesubmit').length > 0) {
    var url = document.URL;
    var params = new URLSearchParams(new URL(url).search);
    orderNumber = params.get('orderNumber');
    serialNumber = params.get('serialNumber');
    isReceiptImage = params.get('isReceiptImage');
    isSerialNumberImage = params.get('isSerialNumberImage');
    isbrokenAreaImage = params.get('isbrokenAreaImage');

    if (isReceiptImage == null){
      $('.receipt-img').addClass('u-display-none');
    }
    if (isSerialNumberImage == null){
      $('.serial-img').addClass('u-display-none');
    }
    if (isbrokenAreaImage == null){
      $('.broken-img').addClass('u-display-none');
    }
    populatePreviews($('#stickwarrantyreesubmit'));

    $('.c-stick-warranty-resubmit-photos').on('click', function(ele) {
      ele.preventDefault();
      const theStickImgForm = $(this).closest('form');
      if($('.c-stick-warranty__container').find('.file-upload').length > 0) {
        error = checkImagesSelected(theStickImgForm);
        if(error) {
          ele.preventDefault();
        } else {
          let personalStickArray = [];
          let stickImgObj = {};
          stickImgObj.dwfrm_stickwarranty_serialnumber = serialNumber;
          $.each($(theStickImgForm).serializeArray(), function(_, kv) {
            stickImgObj[kv.name] = kv.value;
          });
          personalStickArray.push(stickImgObj);
          imgPromise = processImageUploads(personalStickArray,orderNumber, resubmission = true);
          navigateForms('resubmitconfirmation');
        }
      }
    });
  }
}

// Initialize warranty form

window.addEventListener("DOMContentLoaded", function() {
    initWarrantyWindowVar();
    initCountries();
    sessionStorage.setItem('serialNumberError', 'false');
    sessionStorage.setItem('orderNumberError', 'false');
    sessionStorage.setItem('productError', 'false');
    limitCharacters();
    populateModelNumber();
    populateLengthWeight();
    initStickWarrantyForm();
    initCustomStick();
    initStandardStick();
    initresubmitform();
    showContentPopups();
    toggleFormElementes();
})